
(function () {
  'use strict';

  var TEXTE = null;
  function tx(k, rueckfall, werte) {
    if (!TEXTE) {
      try {
        var el = document.querySelector('script[data-setup-texte]');
        if (el) TEXTE = JSON.parse(el.textContent) || {};
      } catch (e) { TEXTE = {}; }
    }
    var s = (TEXTE && TEXTE[k]) || rueckfall || '';
    if (werte) {
      s = s.replace(/\{(\w+)\}/g, function (m, n) { return werte[n] != null ? String(werte[n]) : m; });
    }
    return s;
  }

  var MONITOR_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="2" y="4" width="20" height="13" rx="1.5"/><path d="M9 21h6M12 17v4"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  function ausfall(e) { return !!(e && e.engineAus && window.EngineStatus); }

  function waText() { return tx('wkp_wa_text', 'Hallo, ich habe etwas im Warenkorb und bin mir bei der Passung unsicher. Mein Monitor ist: '); }

  function proxyVon(el) {
    return (window.FinderClean && window.FinderClean.proxy)
      || (el && el.getAttribute('data-wkp-proxy-fallback')) || '/apps/monitor-db';
  }

  function auswahlLesen() {
    try {
      var roh = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null');
      if (!roh || !roh.refs || !roh.refs.length) return null;
      return {
        refs: roh.refs.map(String),
        namen: roh.namen && roh.namen.length ? roh.namen : [roh.name || '']
      };
    } catch (e) { return null; }
  }

  var HOECHSTZAHL = 4;

  function auswahlMerken(ref, name) {
    try {
      var alt = null;
      try { alt = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null'); } catch (e) {}

      var refs = (alt && alt.refs ? alt.refs.map(String) : []);
      var namen = (alt && alt.namen ? alt.namen.slice() : (alt && alt.name ? [alt.name] : []));

      if (refs.indexOf(String(ref)) < 0 && refs.length < HOECHSTZAHL) {
        refs.push(String(ref));
        namen.push(name);
      }

      localStorage.setItem('3idee_auswahl', JSON.stringify({
        refs: refs,
        name: namen[0] || name,
        namen: namen,
        anzahl: refs.length,
        mount: (alt && alt.mount) || '',
        tisch: (alt && alt.tisch) || null,
        pfad: location.pathname,
        zeit: Date.now()
      }));
      document.dispatchEvent(new CustomEvent('finder:auswahl'));
    } catch (e) {}
  }

  var karten = {};
  function skusFuer(proxy, ref) {
    if (karten[ref]) return karten[ref];
    karten[ref] = abruf(proxy + '/monitors/' + encodeURIComponent(ref) + '/compatibility')
      .then(function (json) {
        var menge = {};
        var griffe = {};
        var recs = (json && json.ok && json.data && json.data.recommendations) || [];
        recs.forEach(function (rec) {
          (rec.products || []).forEach(function (p) {
            var sku = String(p.shopify_sku || p.sku || '').trim().toLowerCase();
            if (sku) menge[sku] = true;
            var handle = String(p.handle || '').trim().toLowerCase();
            if (handle) griffe[handle] = true;
          });
        });

        var pflichtOhne = recs.some(function (r) {
          return r.requirement === 'REQUIRED' && !(r.products || []).length;
        });
        var mit = recs.some(function (r) { return (r.products || []).length; });

        return { skus: menge, griffe: griffe, bedarf: pflichtOhne || mit };
      })
      .catch(function () { return null; });
    return karten[ref];
  }

  function zustaende(el, auswahl, antworten) {
    var sku = (el.getAttribute('data-wkp-sku') || '').trim().toLowerCase();
    var griff = (el.getAttribute('data-wkp-handle') || '').trim().toLowerCase();
    var eigene = [];
    try { eigene = JSON.parse(el.getAttribute('data-wkp-refs') || '[]').map(String); } catch (e) {}

    return auswahl.refs.map(function (ref) {
      var inListe = eigene.indexOf(String(ref)) > -1;
      var antwort = antworten[ref];
      if (!inListe && !antwort) return null;
      var empfohlen = antwort && (
        (griff && antwort.griffe && antwort.griffe[griff] === true) ||
        (sku && antwort.skus[sku] === true)
      );
      if (inListe || empfohlen) return 'ok';
      if (antwort && !antwort.bedarf) return 'neutral';
      return 'warn';
    });
  }

  function zeile(name, stufe, wort, zeichen) {
    return '<span class="wkpz">'
      + '<span class="wkpz__mon">' + MONITOR_SVG + esc(name) + '</span>'
      + '<span class="wkpz__linie"></span>'
      + '<span class="wkpz__status wkpz__status--' + stufe + '">'
      +   (zeichen ? '<i>' + zeichen + '</i>' : '') + wort
      + '</span>'
      + '</span>';
  }

  function zeichnen(zeilen, auswahl, antworten) {
    var gedeckt = auswahl.refs.map(function () { return false; });
    var genannt = auswahl.refs.map(function () { return false; });

    zeilen.forEach(function (el) {
      var z = zustaende(el, auswahl, antworten);
      var teile = [];

      var okZahl = {}, okReihe = [];
      z.forEach(function (stufe, i) {
        if (stufe === 'ok') {
          gedeckt[i] = true;
          var nm = auswahl.namen[i] || '';
          if (!okZahl[nm]) { okZahl[nm] = 0; okReihe.push(nm); }
          okZahl[nm]++;
        } else if (stufe === 'neutral') {
          gedeckt[i] = true;
        }
      });
      okReihe.forEach(function (nm) {
        teile.push(zeile((okZahl[nm] > 1 ? okZahl[nm] + '× ' : '') + nm, 'ok', esc(tx('wkp_kompatibel', 'Kompatibel')), '✓'));
      });

      var offene = [];
      z.forEach(function (stufe, k) { if (stufe === 'warn') offene.push(k); });

      if (!teile.length && offene.length === 1) {
        genannt[offene[0]] = true;
        teile.push(zeile(auswahl.namen[offene[0]] || '', 'warn', esc(tx('wkp_nicht_kompatibel', 'Nicht kompatibel')), '✕'));
      } else if (!teile.length && offene.length > 1) {
        teile.push(zeile(tx('wkp_keiner', 'Keiner deiner Monitore'), 'warn', esc(tx('wkp_passt_nicht', 'Passt nicht')), '✕'));
      }

      el.innerHTML = teile.join('');
      el.hidden = !teile.length;
    });

    return { gedeckt: gedeckt, genannt: genannt };
  }

  function luecke(halter, auswahl, stand) {
    var offen = auswahl.refs.map(function (ref, i) {
      return (stand.gedeckt[i] || stand.genannt[i]) ? null : i;
    }).filter(function (i) { return i !== null; });

    var kasten = halter.querySelector('[data-wkp-luecke]');
    if (!offen.length) {
      if (kasten) kasten.remove();
      halter.classList.remove('wkp-halter--sichtbar');
      return;
    }
    if (!kasten) {
      kasten = document.createElement('div');
      kasten.className = 'wkp-luecke';
      kasten.setAttribute('data-wkp-luecke', '');
      halter.appendChild(kasten);
    }
    var offenZahl = {};
    offen = offen.filter(function (i) {
      var nm = auswahl.namen[i] || '';
      offenZahl[nm] = (offenZahl[nm] || 0) + 1;
      return offenZahl[nm] === 1;
    });
    kasten.innerHTML = offen.map(function (i) {
      var nm = auswahl.namen[i] || '';
      return zeile((offenZahl[nm] > 1 ? offenZahl[nm] + '× ' : '') + nm, 'neutral', esc(tx('wkp_nichts_im_korb', 'Nichts dafür im Warenkorb')),'\u2013');
    }).join('');
    halter.classList.add('wkp-halter--sichtbar');
  }

  function feldSetzen(halter) {
    if (halter.querySelector('[data-wkp-form]')) {
      halter.classList.add('wkp-halter--sichtbar');
      return;
    }
    var vorlage = halter.querySelector('[data-wkp-vorlage]');
    if (!vorlage || !vorlage.content) return;
    var kasten = halter.querySelector('[data-wkp-luecke]');
    if (kasten) kasten.remove();
    halter.appendChild(document.importNode(vorlage.content, true));
    halter.classList.add('wkp-halter--sichtbar');
  }

  function feldWeg(halter) {
    var feld = halter.querySelector('.wkp');
    if (feld) feld.remove();
  }


  function plaetzeZeigen(alleZeilen, auswahl) {
    var monitore = (auswahl && auswahl.refs) ? auswahl.refs.length : 0;

    alleZeilen.forEach(function (el) {
      if (el.getAttribute('data-wkp-scope') === 'specific') return;

      var plaetze = Number(el.getAttribute('data-wkp-plaetze')) || 0;
      if (!monitore || !plaetze || plaetze <= monitore) {
        if (el.getAttribute('data-wkp-plaetze-gesetzt')) {
          el.innerHTML = '';
          el.hidden = true;
          el.removeAttribute('data-wkp-plaetze-gesetzt');
        }
        return;
      }

      el.innerHTML = zeile(
        tx('wkp_fuer_plaetze', 'Für {n} Monitore', { n: plaetze }),
        'neutral',
        esc(monitore === 1 ? tx('wkp_ein_hinterlegt', '1 Monitor hinterlegt')
                           : tx('wkp_n_hinterlegt', '{n} hinterlegt', { n: monitore })),
        'i'
      );
      el.hidden = false;
      el.setAttribute('data-wkp-plaetze-gesetzt', '1');
    });
  }

  function aufbauen(halter) {
    var bereich = halter.closest('cart-items-component, .cart-items, form, section') || document;
    var alleZeilen = [].slice.call(bereich.querySelectorAll('[data-wkp-zeile]'));
    var zeilen = alleZeilen.filter(function (el) {
      return el.getAttribute('data-wkp-scope') === 'specific';
    });

    var auswahl = auswahlLesen();

    plaetzeZeigen(alleZeilen, auswahl);

    if (!zeilen.length) return;

    if (!auswahl) {
      zeilen.forEach(function (el) { el.innerHTML = ''; el.hidden = true; });

      if (window.EngineStatus && window.EngineStatus.gestoert()) {
        feldWeg(halter);
        return;
      }


      feldSetzen(halter);
      return;
    }

    var proxy = proxyVon(halter);
    Promise.all(auswahl.refs.map(function (ref) { return skusFuer(proxy, ref); }))
      .then(function (ergebnisse) {
        var antworten = {};
        auswahl.refs.forEach(function (ref, i) { antworten[ref] = ergebnisse[i]; });
        feldWeg(halter);
        luecke(halter, auswahl, zeichnen(zeilen, auswahl, antworten));
      });
  }

  var uhr = null, letzte = '';

  function suchen(feldWurzel, q) {
    if (!feldWurzel) return;
    var treffer = feldWurzel.querySelector('[data-wkp-treffer]');
    if (!treffer) return;
    var proxy = proxyVon(document.querySelector('[data-wkp]'));

    abruf(proxy + '/monitors/search?q=' + encodeURIComponent(q))
      .then(function (json) {
        if (q !== letzte) return;
        var data = (json && json.data) || {};
        var liste = (data.found && data.results && data.results.length)
          ? data.results : (data.similar || []);
        if (!json || !json.ok || !liste.length) {
          treffer.innerHTML = '<b>' + esc(tx('kein_treffer', 'Kein Treffer')) + '</b>';
          treffer.hidden = false;
          return;
        }
        treffer.innerHTML = liste.slice(0, 10).map(function (m) {
          var zus = [];
          if (m.size_inch) zus.push(String(parseFloat(m.size_inch)).replace('.', ',') + '"');
          if (m.year) zus.push(m.year);
          return '<button type="button" data-ref="' + esc(m.ref) + '" data-name="' + esc(m.name) + '">'
            + esc(m.name) + (zus.length ? ' <small>· ' + esc(zus.join(' · ')) + '</small>' : '')
            + '</button>';
        }).join('');
        treffer.hidden = false;
      })
      .catch(function (e) {
        if (q !== letzte) return;
        if (ausfall(e)) {
          treffer.innerHTML = window.EngineStatus.hinweisHtml(
            tx('suche_stoerung', 'Die Modellsuche ist gerade nicht erreichbar. Schreib uns dein Modell — wir sagen dir sofort, was passt.'),
            waText());
          treffer.hidden = false;
          return;
        }
        treffer.hidden = true;
      });
  }

  document.addEventListener('input', function (e) {
    var feld = e.target.closest && e.target.closest('[data-wkp-eingabe]');
    if (!feld) return;
    var wurzel = feld.closest('.wkp');
    var q = feld.value.trim();
    letzte = q;
    clearTimeout(uhr);
    if (q.length < 2) {
      var t = wurzel && wurzel.querySelector('[data-wkp-treffer]');
      if (t) t.hidden = true;
      return;
    }
    uhr = setTimeout(function () { suchen(wurzel, q); }, 180);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-wkp-form]');
    if (!form) return;
    e.preventDefault();
    var feld = form.querySelector('[data-wkp-eingabe]');
    var q = feld ? feld.value.trim() : '';
    letzte = q;
    if (q.length >= 2) suchen(form.closest('.wkp'), q);
  });

  document.addEventListener('click', function (e) {
    var ziel = e.target.closest && e.target.closest('[data-wkp-treffer] [data-ref]');
    if (ziel) {
      auswahlMerken(ziel.getAttribute('data-ref'), ziel.getAttribute('data-name'));
      return;
    }
  });

  function alle() {
    document.querySelectorAll('[data-wkp]').forEach(function (h) { aufbauen(h); });
  }

  var wartet = null;
  function bald() {
    clearTimeout(wartet);
    wartet = setTimeout(alle, 60);
  }

  if (document.readyState !== 'loading') alle();
  else document.addEventListener('DOMContentLoaded', alle);

  document.addEventListener('shopify:cart:lines-update', bald);
  document.addEventListener('finder:auswahl', bald);

  document.addEventListener('engine:status', bald);

  var schublade = document.getElementById('cart-drawer');
  if (schublade && window.MutationObserver) {
    new MutationObserver(function (liste) {
      var fremd = liste.some(function (m) {
        var el = m.target;
        if (!el || !el.closest) return true;
        return !el.closest('[data-wkp-zeile]') && !el.closest('[data-wkp]');
      });
      if (fremd) bald();
    }).observe(schublade, { childList: true, subtree: true });
  }
})();
